import { render, staticRenderFns } from "./ProgramaPersonaPage.vue?vue&type=template&id=86373ea8&scoped=true&"
import script from "./ProgramaPersonaPage.js?vue&type=script&lang=js&"
export * from "./ProgramaPersonaPage.js?vue&type=script&lang=js&"
import style0 from "./ProgramaPersonaPage.vue?vue&type=style&index=0&id=86373ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86373ea8",
  null
  
)

export default component.exports